import React, { Component } from 'react'
import Chart from '@common/Chart'
import { toJS } from 'mobx'
import { isTelSaleCityMerchant } from '@util'

export default class extends Component {
  getOption = data => {
    data = data || []

    const telSaleCityMerchant = isTelSaleCityMerchant()

    let count_date = []
    let zgt_expo_num = []
    let expo_num = []
    let ydt_display_view = []
    for (let i in toJS(data)) {
      count_date.push(data[i].count_date)
      zgt_expo_num.push(data[i].zgt_expo_num)
      expo_num.push(data[i].expo_num)
      ydt_display_view.push(data[i].ydt_display_view)
    }

    const option = {
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        data: telSaleCityMerchant
          ? ['总曝光']
          : ['总曝光', '智优投曝光', '智推宝曝光']
      },
      toolbox: {
        show: false
      },
      xAxis: {
        type: 'category',
        data: count_date
      },
      yAxis: {
        type: 'value',
        name: '单位(次)',
        splitLine: { show: false }
      },
      series: [
        {
          name: '总曝光',
          data: expo_num,
          type: 'line'
        },
        !telSaleCityMerchant
          ? {
              name: '智优投曝光',
              data: zgt_expo_num,
              type: 'line'
            }
          : null,
        !telSaleCityMerchant
          ? {
              name: '智推宝曝光',
              data: ydt_display_view,
              type: 'line'
            }
          : null
      ].filter(Boolean),
      color: ['#448afc', '#2FC286', '#000000']
    }

    return option
  }

  render() {
    const { data } = this.props
    return <Chart option={this.getOption(data)} />
  }
}
